import { RefObject, useRef, useState, useContext, ChangeEvent, JSX } from 'react';

import { WorkflowSettings } from "./WorkflowSettings";
import { WorkflowTesting } from "./WorkflowTesting";
import SettingsIcon from '@mui/icons-material/Settings';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { WorkflowContext } from "../context/WorkflowContextProvider";
import PublishIcon from '@mui/icons-material/Publish';
import GetAppIcon from '@mui/icons-material/GetApp';
import CloseIcon from '@mui/icons-material/Close';
import {
    useRecordContext,
    useNotify
} from 'react-admin';
import {
    Drawer
} from '@mui/material';

export const WorkflowControls: () => JSX.Element = (): JSX.Element => {
    const context: any = useContext(WorkflowContext);
    const [showPanel, setShowPanel] = useState<boolean>(true);
    const record = useRecordContext();
    const notify: any = useNotify();

    function showSettings() : void {
        context.toggleShowTestWindow(false)
    }

    function showTesting() : void {
        context.toggleShowTestWindow(true)
    }

    function getWidthIcon(): JSX.Element {
        if (showPanel) {
            return <ChevronRightIcon />;
        } else {
            return <ChevronLeftIcon />;
        }
    }

    function handleCloseControlsClick(): void {
        context.toggleShowControlsDrawer(false);
    }

    function handleExportWorkflowClick(): void {
        let name: string = record?.name ?? 'untitled_workflow';
        const response: string = context.exportWorkflowDataToFile(name);
        if (response !== 'success') {
            notify(response, { type: 'error' })
        }
    }

    async function handleFileChangeEvent(event : ChangeEvent<HTMLInputElement>): Promise<void> {
        event.preventDefault();
        const reader = new FileReader();
        reader.onload = async (e: ProgressEvent<FileReader>): Promise<void> => {
            const text: string | ArrayBuffer = (e.target.result);
            const response: string = context.importWorkflowDataFromFile(text);
            if (response !== 'success') {
                notify(response, { type: 'error' })
            }
        }
        reader.readAsText(event.target.files[0]);
    }


    return (
        <Drawer open={ context.showControlsDrawer }
                anchor="right"
                className="drawer__workflow-controls"
                onClose={ (): any => context.toggleShowControlsDrawer(false) } >
            <div className="workflow-controls">
                <div className="workflow-controls">
                    { /* One header row: the two panels lead, because switching
                         between them is the thing you do most. Import and
                         export are utilities on the workflow as a whole, so
                         they trail, and close sits last behind a divider. */ }
                    <div className="workflow-controls__controls">
                        <div className="controls__tabs">
                            <div className={ "button" + ( context.showTestWindow === false ? ' is-active' : '' ) }
                                 onClick={ showSettings } >
                                <span>{ "Configuration" }</span>
                                <SettingsIcon />
                            </div>
                            <div className={ "button"
                                    + ( context.showTestWindow === true ? ' is-active' : '' )
                                    + ( context.interruptWaiting ? ' interruptWaiting' : '' ) }
                                 onClick={ showTesting } >
                                <span>{ "Test" }</span>
                                <PlayArrowIcon />
                            </div>
                        </div>

                        <div className="controls__actions">
                            <label
                                onClick={ handleExportWorkflowClick }
                                title={ "Export workflow" }
                                className="button action">
                                <PublishIcon />
                            </label>
                            <label htmlFor="workflow_imported"
                                   title={ "Import workflow" }
                                   className="button action">
                                <input type="file"
                                       onChange={ handleFileChangeEvent }
                                       style={ { position: 'absolute', right: '-9999999px', display: 'none' } }
                                       id="workflow_imported" />
                                <GetAppIcon />
                            </label>
                        </div>

                        <span className="controls__divider" />

                        <button type="button"
                                className="controls__close"
                                title="Close"
                                onClick={ handleCloseControlsClick }>
                            <CloseIcon />
                        </button>
                    </div>
                    <div className="workflow-controls__container">
                        { (context.showTestWindow === true) &&
                            <div className="container__testing" >
                                <WorkflowTesting />
                            </div>
                        }
                        { (context.showTestWindow === false) &&
                            <div className="container__settings" >
                                <WorkflowSettings />
                            </div>
                        }
                    </div>
                </div>
            </div>
        </Drawer>
    );
}